import React from 'react';

import subProgramClasses from 'components/widgets/SubProgramPreferences/SubProgramPreferences.module.scss';
import { ProgressMeasurementPreference } from 'components/widgets/SubProgramPreferences/components/progressMeasurement/components/progressMeasurementPreference/progressMeasurementPreference';
import classes from 'components/widgets/SubProgramPreferences/components/progressMeasurement/progressMeasurement.module.scss';

export const ProgressMeasurement = () => {
    return (
        <div data-testid={'progress-measurement'} className={classes.progressMeasurement}>
            <span className={subProgramClasses.title}>Progress Measurement: </span>
            <div className={classes.container}>
                <ProgressMeasurementPreference />
            </div>
        </div>
    );
};
